import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {AuthenticationEffects} from "./core/authentication.effects";
import {EffectsModule} from "@ngrx/effects";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/authentication.reducer";
import {LoginLeftPanelComponent} from './pages/login/login-left-panel/login-left-panel.component';
import {LoginRightPanelComponent} from './pages/login/login-right-panel/login-right-panel.component';
import {AuthenticationRoutingModule} from "./authentication.routing";
import {StepOneLeftPanelComponent} from './pages/register/step-one/step-one-left-panel/step-one-left-panel.component';
import {
  StepOneRightPanelComponent
} from './pages/register/step-one/step-one-right-panel/step-one-right-panel.component';
import {StepTwoLeftPanelComponent} from './pages/register/step-two/step-two-left-panel/step-two-left-panel.component';
import {
  StepTwoRightPanelComponent
} from './pages/register/step-two/step-two-right-panel/step-two-right-panel.component';
import {
  SetPasswordLeftPanelComponent
} from './pages/set-password/set-password-left-panel/set-password-left-panel.component';
import {
  SetPasswordRightPanelComponent
} from './pages/set-password/set-password-right-panel/set-password-right-panel.component';
import {
  ForgotPasswordRightPanelComponent
} from './pages/forgot-password/forgot-password-right-panel/forgot-password-right-panel.component';
import {
  ForgotPasswordLeftPanelComponent
} from './pages/forgot-password/forgot-password-left-panel/forgot-password-left-panel.component';
import {SharedModule} from "../shared/shared.module";
import {
  StepFourLeftPanelComponent
} from './pages/register/step-four/step-four-left-panel/step-four-left-panel.component';
import {
  StepFourRightPanelComponent
} from './pages/register/step-four/step-four-right-panel/step-four-right-panel.component';
import {
  StepFiveLeftPanelComponent
} from './pages/register/step-five/step-five-left-panel/step-five-left-panel.component';
import {
  StepFiveRightPanelComponent
} from './pages/register/step-five/step-five-right-panel/step-five-right-panel.component';
import {AdultInfoFormComponent} from './pages/register/step-five/components/adult-info-form/adult-info-form.component';
import {
  ParticipantInfoFormComponent
} from './pages/register/step-five/components/participant-info-form/participant-info-form.component';
import {
  ClientAdminInfoFormComponent
} from './pages/register/step-five/components/client-admin-info-form/client-admin-info-form.component';
import {CoachInfoFormComponent} from './pages/register/step-five/components/coach-info-form/coach-info-form.component';
import {
  StepThreeRightPanelComponent
} from './pages/register/step-three/step-three-right-panel/step-three-right-panel.component';
import {
  StepThreeLeftPanelComponent
} from './pages/register/step-three/step-three-left-panel/step-three-left-panel.component';
import {MatOptionModule} from "@angular/material/core";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { WarningLeftPanelComponent } from './pages/warning/warning-left-panel/warning-left-panel.component';
import { WarningRightPanelComponent } from './pages/warning/warning-right-panel/warning-right-panel.component';
import { MessageLeftPanelComponent } from './pages/message/message-left-panel/message-left-panel.component';
import { MessageRightPanelComponent } from './pages/message/message-right-panel/message-right-panel.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';


@NgModule({
  declarations: [
    LoginLeftPanelComponent,
    LoginRightPanelComponent,
    StepOneLeftPanelComponent,
    StepOneRightPanelComponent,
    StepTwoLeftPanelComponent,
    StepTwoRightPanelComponent,
    SetPasswordLeftPanelComponent,
    SetPasswordRightPanelComponent,
    ForgotPasswordRightPanelComponent,
    ForgotPasswordLeftPanelComponent,
    StepFourLeftPanelComponent,
    StepFourRightPanelComponent,
    StepFiveLeftPanelComponent,
    StepFiveRightPanelComponent,
    AdultInfoFormComponent,
    ParticipantInfoFormComponent,
    ClientAdminInfoFormComponent,
    CoachInfoFormComponent,
    StepThreeRightPanelComponent,
    StepThreeLeftPanelComponent,
    WarningLeftPanelComponent,
    WarningRightPanelComponent,
    MessageLeftPanelComponent,
    MessageRightPanelComponent,

  ],

  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    StoreModule.forFeature('ss-cord.authentication', reducer),
    EffectsModule.forFeature(
      [AuthenticationEffects]
    ),
    SharedModule,
    MatOptionModule,
    NgOptimizedImage,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule
  ]
})
export class AuthenticationModule {
}
